exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul li > a {\r\n  cursor: pointer;\r\n  color: white;\r\n}\r\n\r\nul li.language a:hover {\r\n  background: white;\r\n  color: #c00000;\r\n}\r\n\r\n.lang {\r\n  display: inline-block;\r\n  border-right: solid white 1px;\r\n  max-height: 50px;\r\n  padding-right: 10px;\r\n  padding-left: 10px;\r\n}\r\n\r\nul li.drop:hover {\r\n  background: white;\r\n}\r\n\r\nul li.drop:hover a {\r\n  color: #c00000;\r\n}\r\n\r\n.space {\r\n  min-width:30px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/header/main-menu/desktop-menu/desktop-menu.component.css
// module id = ../../../../../src/app/header/main-menu/desktop-menu/desktop-menu.component.css
// module chunks = main